export const bs = {
  // Common
  common: {
    save: 'Sačuvaj',
    cancel: 'Otkaži',
    delete: 'Obriši',
    edit: 'Izmeni',
    add: 'Dodaj',
    search: 'Pretraži',
    searchGroups: 'Pretraži grupe...',
    searchVehicles: 'Pretraži vozila...',
    noGroupsFound: 'Nema pronađenih grupa',
    noVehiclesFound: 'Nema pronađenih vozila',
    searchDrivers: 'Pretraži vozače...',
    noDriversFound: 'Nema pronađenih vozača',
    loading: 'Učitavanje...',
    noData: 'Nema podataka',
    today: 'Danas',
    yesterday: 'Jučer',
    thisWeek: 'Ova sedmica',
    last7Days: 'Posljednjih 7 dana',
    last30Days: 'Posljednjih 30 dana',
    thisMonth: 'Ovaj mjesec',
    customRange: 'Prilagođeni period',
    backToPresets: 'Nazad na periode',
    all: 'Sve',
    showing: 'Prikazano',
    to: 'do',
    of: 'od',
    entries: 'unosa',
    page: 'Stranica',
    rows: 'redova',
    refresh: 'Osveži',
    selectAll: 'Odaberi sve',
    selectRow: 'Odaberi red',
    pageNotFound: 'Ups! Stranica nije pronađena',
    returnToHome: 'Nazad na početnu',
    kilometersShort: 'km',
    kilometersPerHourShort: 'km/h',
    litersShort: 'L',
    litersPer100KmShort: 'L/100km',
    exportFailed: 'Izvoz nije uspio',
    exportPdf: 'Izvezi PDF',
    exportExcel: 'Izvezi Excel',
    pdfExported: 'PDF izvezen',
    excelExported: 'Excel izvezen',
    exportSuccess: 'je uspješno preuzet.',
    dateRangeLabel: 'Opseg datuma',
    generatedLabel: 'Generisano',
    exportedBy: 'Izvezao',
    totalsLabel: 'Ukupno',
    records: 'zapisa',
    total: 'Ukupno',
    hoursShort: 'h',
    minutesShort: 'm',
    secondsShort: 's',
    percentSymbol: '%',
    previous: 'Prethodno',
    next: 'Sljedeće',
    more: 'Više',
    morePages: 'Još stranica',
    close: 'Zatvori',
    toggleSidebar: 'Prikaži/sakrij meni',
    previousSlide: 'Prethodni slajd',
    nextSlide: 'Sledeći slajd',
    pagination: 'Paginacija',
    breadcrumb: 'Putanja',
  },

  // Navigation
  nav: {
    liveTracking: 'Praćenje uživo',
    history: 'Historija',
    vehicles: 'Vozila',
    drivers: 'Vozači',
    zones: 'Zone',
    poi: 'Tačke interesa',
    reports: 'Izvještaji',
    notifications: 'Obavještenja',
    costs: 'Troškovi',
    editProfile: 'Uredi profil',
    editProfileDesc: 'Izmijenite ime, kontakt podatke i lozinku',
    profileUpdated: 'Profil je ažuriran',
    userSettings: 'Podešavanja korisnika',
    systemSettings: 'Sistemska podešavanja',
    signOut: 'Odjava',
    language: 'Jezik',
    settings: 'Podešavanja',
    groups: 'Grupe',
    users: 'Korisnici',
    activity: 'Dnevnik aktivnosti',
  },

  // Auth
  auth: {
    welcomeBack: 'Dobrodošli nazad',
    signInToContinue: 'Prijavite se na svoj nalog da nastavite',
    username: 'Korisničko ime',
    email: 'Email',
    password: 'Lozinka',
    signIn: 'Prijava',
    signingIn: 'Prijavljivanje...',
    fleetManagementSystem: 'Sistem za upravljanje flotom',
    demoCredentials: 'Demo: Koristite bilo koji email i lozinku (min 6 karaktera)',
    invalidCredentials: 'Pogrešni podaci za prijavu',
    enterCredentials: 'Molimo unesite vaše podatke',
    passwordMinLength: 'Lozinka mora imati najmanje 6 karaktera',
    sessionExpired: 'Vaša sesija je istekla. Prijavite se ponovo.',
    appName: 'Global GPS',
    usernamePlaceholder: 'korisničko ime',
    passwordPlaceholder: '••••••••',
    realTimeGpsTracking: 'GPS praćenje u realnom vremenu',
    monitorFleet247: 'Pratite vašu flotu 24/7',
    routeHistory: 'Historija ruta',
    detailedVehicleData: 'Detaljni podaci o vozilu za svaku vožnju',
    enterpriseSecurity: 'Sigurnost za poduzeća',
    encryptedDataRoleBasedAccess: 'Šifrirani podaci i pristup po ulogama',
    pro: 'Pro',
  },

  apiErrors: {
    invalid_preferences: 'Postavke obavještenja nije moguće sačuvati',
    missing_credentials: 'Korisničko ime i lozinka su obavezni',
    invalid_credentials: 'Pogrešno korisničko ime ili lozinka',
    missing_api_key: 'Prijavite se da biste nastavili',
    invalid_token: 'Vaša sesija je istekla. Prijavite se ponovo.',
    invalid_user: 'Korisnički nalog nije pronađen',
    group_in_use: 'Grupa se ne može obrisati dok su korisnici ili vozila dodeljeni',
    username_exists: 'Korisničko ime već postoji',
    cannot_delete_self: 'Ne možete obrisati vlastiti nalog',
    not_found: 'Traženi resurs nije pronađen',
    forbidden: 'Nemate dozvolu za ovu akciju',
    missing_fields: 'Popunite sva obavezna polja',
    missing_id: 'Nedostaje ID resursa',
    method_not_allowed: 'Akcija nije dozvoljena',
    invalid_group: 'Izabrana grupa nije validna',
    invalid_device: 'To vozilo vam nije dostupno',
    invalid_category: 'Ta kategorija nije dostupna',
    category_in_use: 'Kategorija se koristi ili taj kod već postoji',
    recurrence_in_use: 'Ovo pravilo je već generisalo troškove i ne može se obrisati',
    invalid_rule: 'Pravilo ponavljanja je nepotpuno ili neispravno',
    readonly_field: 'Polje samo za čitanje se ne može mijenjati',
    server_error: 'Server nije mogao sačuvati izmjenu. Ništa nije sačuvano.',
    request_failed: 'Zahtjev nije uspeo. Pokušajte ponovo.',
    invalid_request: 'Neispravan format zahtjeva',
    invalid_response: 'Neočekivan odgovor servera',
  },

  // Live Tracking
  tracking: {
    vehicles: 'Vozila',
    searchVehicles: 'Pretraži vozila...',
    visible: 'Vidljivo',
    moving: 'U pokretu',
    idle: 'Miruje',
    stopped: 'Zaustavljeno',
    offline: 'Van mreže',
    following: 'Praćenje',
    speed: 'Brzina',
    altitude: 'Visina',
    satellites: 'Sateliti',
    fuelLevel: 'Nivo goriva',
    fuelUsed: 'Potrošeno goriva',
    distance: 'Udaljenost',
    engineTemp: 'Temp. motora',
    rpm: 'Obrtaji',
    heading: 'Smjer',
    fuel: 'Gorivo',
    ignition: 'Paljenje',
    on: 'Uključeno',
    off: 'Isključeno',
    sensors: 'Senzori',
    history: 'Historija',
    settings: 'Podešavanja',
    trackVehicle: 'Prati ovo vozilo',
    stopTracking: 'Zaustavi praćenje',
    hideDetails: 'Sakrij detalje',
    showDetails: 'Prikaži detalje',
    noCoordinates: 'Nema koordinata (skriveno na mapi)',
    withoutCoordinates: 'Bez koordinata',
    isolateStatusHint: 'Dvoklik prikazuje samo ovaj status',
    overview: 'Pregled',
    general: 'Opšte',
    sentData: 'Poslati podaci',
    reports: 'Izvještaji',
    lastUpdate: 'Posljednje ažuriranje',
    lastUpdateUnderMinute: '<1 min',
    lastUpdateMinutesUnit: 'min',
    latestInputs: 'Najnoviji ulazi',
    noSensorData: 'Nema podataka sa senzora',
    openReportsForVehicle: 'Otvori izveštaje filtrirane za ovo vozilo.',
    openReports: 'Otvori izveštaje',
    followingGroup: 'Praćenje grupe',
    make: 'Marka',
    model: 'Model',
    year: 'Godina',
    registration: 'Registracija',
    deviceId: 'ID uređaja',
    noData: 'Nema podataka',
    viewHistory: 'Pogledaj historiju vozila',
    driver: 'Vozač',
    goToHistory: 'Idi na historiju',
    vehicleTable: 'Tabela vozila',
    vehicleTableDesc: 'Sva vozila sa najnovijom telemetrijom, grupisana po grupi vozila.',
  },

  // Map
  map: {
    street: 'Ulična',
    muted: 'Prigušena',
    satellite: 'Satelitska',
    dark: 'Tamna',
    terrain: 'Teren',
  },

  // History
  historyPage: {
    title: 'Historija i izvještaji',
    subtitle: 'Pregled historije putovanja, ruta i događaja',
    group: 'Grupa',
    allGroups: 'Sve grupe',
    vehicle: 'Vozilo',
    allVehicles: 'Sva vozila',
    period: 'Period',
    startTime: 'Vrijeme početka',
    endTime: 'Vrijeme završetka',
    invalidDateRange: 'Datum i vrijeme završetka moraju biti nakon datuma i vremena početka.',
    loadHistory: 'Učitaj historiju',
    filtersChanged: 'Filteri su promijenjeni. Kliknite “Učitaj historiju” za osvježavanje.',
    loadHistoryPrompt: 'Postavite filtere i kliknite “Učitaj historiju” za prikaz putovanja.',
    trips: 'Putovanja',
    distance: 'Udaljenost',
    distanceTotal: 'Ukupna udaljenost',
    fuelTotal: 'Ukupno gorivo',
    avgSpeed: 'Prosječna brzina',
    events: 'Događaji',
    distanceByDay: 'Udaljenost po danu',
    eventsByType: 'Događaji po tipu',
    noEvents: 'Nema događaja u izabranom periodu',
    /** Keyed by the upstream `has_<type>` suffix; unknown types fall back to a humanized label. */
    routeEvents: {
      speeding: 'Prekoračenje brzine vozila',
      street_speeding: 'Prekoračenje ograničenja',
      fuel_drain: 'Istakanje goriva',
      refuel: 'Tankanje goriva',
      parking_zone_changed: 'Promjena parking zone',
      go_zone_changed: 'Promjena zone vožnje',
      nogo_zone_changed: 'Promjena zabranjene zone',
    },
    start: 'Početak',
    end: 'Kraj',
    duration: 'Trajanje',
    viewRoute: 'Prikaži rutu',
    route: 'Ruta',
    maxSpeed: 'Maks. brzina',
    speedViolation: 'Prekoračenje brzine',
    harshBrake: 'Naglo kočenje',
    harshAcceleration: 'Naglo ubrzanje',
    idle: 'Mirovanje',
    fuel: 'Gorivo',
    fuelConsumed: 'Utrošeno gorivo',
    avgConsumption: 'Prosječna potrošnja',
    geofence: 'Geofence',
    routeStop: 'Zaustavljanje',
    groupBy: 'Grupisanje',
    groupByNone: 'Bez grupisanja',
    groupByDateVehicle: 'Datum → Vozilo',
    groupByVehicleDate: 'Vozilo → Datum',
    continued: 'nastavak',
    tooManyRoutes: 'ruta učitano — prikaz može biti spor. Suzite vremenski period ili izaberite manje vozila.',
    statsToggle: 'Statistika',
    showChart: 'Prikaži grafikon',
    hideChart: 'Sakrij grafikon',
    exportMapPdf: 'Izvezi mapu (PDF)',
    mapExportTitle: 'Mapa rute',
    pointReadout: 'Vrijednosti u označenoj tački',
    pointTime: 'Vrijeme',
  },

  // Vehicles
  vehiclesPage: {
    title: 'Vozila',
    subtitle: 'Upravljanje vozilima i podešavanjima flote',
    addVehicle: 'Dodaj vozilo',
    addNewVehicle: 'Dodaj novo vozilo',
    addNewVehicleDesc: 'Dodajte novo vozilo u vašu flotu',
    vehicleName: 'Naziv vozila',
    plateNumber: 'Registracija',
    deviceId: 'ID',
    selectGroup: 'Izaberite grupu',
    selectDriver: 'Izaberite vozača',
    noDriver: 'Bez vozača',
    driverAlreadyAssignedTitle: 'Vozač je već dodijeljen',
    driverAlreadyAssignedDesc: 'Ovaj vozač je već dodijeljen vozilima ispod. Nastavak zadržava te dodjele i dodaje ovu.',
    driverName: 'Ime vozača',
    totalVehicles: 'Ukupno vozila',
    vehicleGroups: 'Grupe vozila',
    allVehicles: 'Sva vozila',
    odometer: 'Kilometraža',
    tankCapacity: 'Kapacitet rezervoara (L)',
    make: 'Marka',
    model: 'Model',
    year: 'Godište',
    vehicleUpdated: 'Vozilo je ažurirano',
    maxSpeed: 'Maksimalna brzina',
    trackSpeeding: 'Prati maks. brzinu vozila',
    trackStreetSpeeding: 'Prati ograničenje na ulici',
    speedControl: 'Kontrola brzine',
    editSelected: 'Izmijeni odabrana',
    selectedCount: '{count} odabrano',
    bulkEditTitle: 'Izmjena odabranih vozila',
    bulkEditDesc: 'Samo polja koja omogućite ispod biće promijenjena na odabranim vozilima.',
    changeField: 'Promijeni ovo polje',
    clearSelection: 'Poništi odabir',
    bulkUpdated: '{count} vozila ažurirano',
    bulkUpdatedPartial: '{updated} ažurirano, {failed} neuspješno',
    allGroups: 'Sve grupe',
  },

  // Drivers
  driversPage: {
    title: 'Vozači',
    subtitle: 'Upravljanje vozačima i dodelama vozila',
    addDriver: 'Dodaj vozača',
    addNewDriver: 'Dodaj novog vozača',
    addNewDriverDesc: 'Dodajte novog vozača u vašu flotu',
    editDriver: 'Izmeni vozača',
    editDriverDesc: 'Ažurirajte informacije o vozaču',
    fullName: 'Ime i prezime',
    phone: 'Telefon',
    rfid: 'RFID',
    license: 'Dozvola',
    licenseNumber: 'Broj dozvole',
    licenseExpiry: 'Datum isteka dozvole',
    address: 'Adresa',
    city: 'Grad',
    zip: 'Poštanski broj',
    expires: 'Ističe',
    assignedVehicle: 'Dodijeljeno vozilo',
    assignVehicle: 'Dodijeli vozilo',
    selectVehicle: 'Odaberi vozilo',
    status: 'Status',
    active: 'Aktivan',
    inactive: 'Neaktivan',
    onLeave: 'Na odsustvu',
    unassigned: 'Nedodeljen',
    totalDrivers: 'Ukupno vozača',
    assigned: 'Dodijeljeno',
    allDrivers: 'Svi vozači',
    saveChanges: 'Sačuvaj izmene',
    driverAdded: 'Vozač uspješno dodat',
    driverUpdated: 'Vozač uspješno ažuriran',
    driverDeleted: 'Vozač uspješno obrisan',
    assignedVehicles: 'Dodijeljena vozila',
    assignmentUpdated: 'Dodjela vozila ažurirana',
    firstNamePlaceholder: 'Marko',
    lastNamePlaceholder: 'Marković',
  },

  // Zones
  zonesPage: {
    title: 'Zone',
    subtitle: 'Upravljanje geofence zonama za vašu flotu',
    drawZone: 'Nacrtaj zonu',
    undoPoint: 'Poništi tačku',
    points: 'tačaka',
    totalZones: 'Ukupno zona',
    parking: 'Parking',
    noGo: 'Zabranjena',
    driving: 'Vožnja',
    custom: 'Prilagođena',
    parkingZone: 'Parking zona',
    noGoZone: 'Zabranjena zona',
    drivingZone: 'Zona vožnje',
    customZone: 'Prilagođena zona',
    zoneMap: 'Mapa zona',
    zoneList: 'Lista zona',
    createZone: 'Kreiraj zonu',
    createZoneDesc: 'Imenujte i konfigurišite vašu novu zonu',
    editZone: 'Izmeni zonu',
    editZoneDesc: 'Ažurirajte podešavanja zone',
    zoneName: 'Naziv zone',
    zoneType: 'Tip zone',
    clickToAdd: 'Kliknite na mapu da dodate tačke',
    noZones: 'Nema kreiranih zona. Kliknite "Nacrtaj zonu" da kreirate.',
    zoneCreated: 'Zona uspješno kreirana',
    zoneUpdated: 'Zona uspješno ažurirana',
    zoneDeleted: 'Zona uspješno obrisana',
    needMorePoints: 'Zona zahtijeva najmanje 3 tačke',
    zoneNamePlaceholder: 'npr. Glavni parking',
    shape: 'Oblik',
    clearPoints: 'Obriši tačke',
    pointLabel: 'Tačka',
    noPointsYet: 'Kliknite na mapu da postavite prvu tačku obrisa zone.',
    drawInstructions: 'Nastavite klikati na mapu da dodate tačke. Koristite Poništi ili Obriši za ispravku.',
    zoneDescription: 'Opis',
    zoneDescriptionPlaceholder: 'Opcione napomene o zoni',
  },

  // POI
  poiPage: {
    title: 'Tačke interesa',
    subtitle: 'Upravljanje lokacijama i kontaktima',
    addPoi: 'Dodaj POI',
    addPoiTitle: 'Dodaj tačku interesa',
    addPoiDesc: 'Dodajte novu lokaciju na vašu mapu',
    editPoiTitle: 'Izmeni tačku interesa',
    editPoiDesc: 'Ažurirajte informacije o POI',
    total: 'Ukupno',
    partner: 'Partner',
    gasStation: 'Benzinska pumpa',
    warehouse: 'Skladište',
    customer: 'Kupac',
    serviceCenter: 'Servisni centar',
    other: 'Ostalo',
    poiMap: 'POI mapa',
    poiList: 'POI lista',
    name: 'Naziv',
    type: 'Tip',
    address: 'Adresa',
    latitude: 'Geografska širina',
    longitude: 'Geografska dužina',
    clickToSelect: 'Kliknite na mapu da odaberete lokaciju',
    contactPerson: 'Kontakt osoba',
    contactPhone: 'Kontakt telefon',
    contactEmail: 'Kontakt email',
    description: 'Opis',
    descriptionPlaceholder: 'Opcioni opis ove lokacije',
    notes: 'Napomene',
    additionalNotes: 'Dodatne napomene...',
    noPois: 'Nema kreiranih POI. Kliknite "Dodaj POI" da kreirate.',
    poiAdded: 'POI uspješno dodat',
    poiUpdated: 'POI uspješno ažuriran',
    poiDeleted: 'POI uspješno obrisan',
    namePlaceholder: 'npr. Glavna kancelarija',
    addressPlaceholder: 'Glavna 123, Grad',
    contactPersonPlaceholder: 'Petar Petrović',
    contactPhonePlaceholder: '+381 60 123 4567',
    contactEmailPlaceholder: 'kontakt@firma.rs',
    location: 'Lokacija',
    dragMarkerHint: 'Povucite marker ili kliknite na mapu da ga pomjerite.',
  },

  // Reports
  reportsPage: {
    title: 'Izvještaji',
    subtitle: 'Generišite i izvezite prilagođene izveštaje flote',
    generateReport: 'Generiši izveštaj',
    filtersChanged: 'Filteri su promenjeni. Kliknite “Generiši izveštaj” da osvežite.',
    reportType: 'Tip izveštaja',
    tripReport: 'Izvještaj o putovanjima',
    fuelReport: 'Izvještaj o gorivu',
    driverReport: 'Izvještaj o vozačima',
    vehicleUtilization: 'Iskorišćenost vozila',
    dateRange: 'Opseg datuma',
    pickDateRange: 'Izaberite opseg datuma',
    invalidDateRange: 'Datum i vrijeme završetka moraju biti nakon datuma i vremena početka.',
    tripReportDesc: 'Redovi putovanja iz API istorije ruta: registarske oznake, segmenti, udaljenosti, brzine, uzorci tačaka',
    fuelReportDesc: 'Tankanja goriva po vozilu: koliko puta, koliko ukupno i kada je posljednje',
    driverReportDesc: 'Zbir po vozaču iz istorije ruta (udaljenost, vrijeme, brzine) i vožena vozila',
    vehicleReportDesc: 'Zbir po vozilu iz istorije ruta (udaljenost, vrijeme, brzine) i dodijeljena grupa',
    startTime: 'Vrijeme početka',
    endTime: 'Vrijeme završetka',
    refuelCount: 'Broj tankanja',
    refuelledTotalL: 'Ukupno natočeno (L)',
    lastRefuel: 'Posljednje tankanje',
    drainCount: 'Broj istakanja',
    startLocation: 'Početna lokacija',
    endLocation: 'Krajnja lokacija',
    distanceKm: 'Udaljenost (km)',
    durationMin: 'Trajanje (min)',
    avgSpeedKmh: 'Prosječna brzina (km/h)',
    fuelL: 'Utrošeno gorivo (L)',
    avgConsumption: 'Prosječna potrošnja',
    routeNo: 'Ruta br.',
    pointsCount: 'Uzorkovanih tačaka',
    totalDurationMinutes: 'Ukupno trajanje (min)',
    totalDurationHms: 'Ukupno trajanje (hh:mm:ss)',
    dateTime: 'Datum/Vrijeme',
    location: 'Lokacija',
    odometerKm: 'Kilometraža (km)',
    driver: 'Vozač',
    totalTrips: 'Ukupno putovanja',
    totalDistanceKm: 'Ukupno udaljenost (km)',
    group: 'Grupa',
    fuelLevelPercent: 'Nivo goriva (%)',
    showingFirst: 'Prikazano prvih',
    ofRecords: 'zapisa. Izvezite da vidite sve podatke.',
    allTime: 'Cijeli period',
    refuel: 'Tankanje',
    consumption: 'Potrošnja',
    theft: 'Krađa',
  },

  // Notifications
  notificationsPage: {
    settings: 'Postavke obavještenja',
    title: 'Obavještenja',
    unreadNotifications: 'nepročitanih obavještenja',
    allCaughtUp: 'Sve ste pročitali!',
    markAllRead: 'Označi sve kao pročitano',
    total: 'Ukupno',
    alerts: 'Upozorenja',
    warnings: 'Upozorenja',
    unread: 'Nepročitano',
    noNotifications: 'Nema obavještenja',
    youreAllCaughtUp: 'Sve ste pročitali!',
  },

  // Live vehicle events (docs/Events.MD) and their toast preferences
  vehicleEvents: {
    types: {
      parking_enter: 'Vozilo je ušlo u parking zonu',
      parking_exit: 'Vozilo je napustilo parking zonu',
      go_zone_enter: 'Vozilo je ušlo u dozvoljenu zonu',
      go_zone_exit: 'Vozilo je napustilo dozvoljenu zonu',
      nogo_zone_enter: 'Vozilo je ušlo u zabranjenu zonu',
      nogo_zone_exit: 'Vozilo je napustilo zabranjenu zonu',
      driver_identified: 'Vozač identifikovan',
      driver_removed: 'Vozač uklonjen',
      driver_changed: 'Vozač promijenjen',
      started: 'Motor upaljen',
      stopped: 'Motor ugašen',
      speeding_start: 'Vozilo je prekoračilo brzinu (ograničenje vozila)',
      speeding_end: 'Vozilo je ponovo ispod ograničenja vozila',
      street_speeding_start: 'Vozilo je prekoračilo ograničenje na cesti',
      street_speeding_end: 'Vozilo je ponovo ispod ograničenja na cesti',
      refuel: 'Točenje goriva',
      missing_fuel: 'Pad nivoa goriva',
      overheat: 'Pregrijavanje motora',
    },
    categories: {
      zone: 'Zone',
      driver: 'Vozač',
      engine: 'Motor',
      speed: 'Brzina',
      fuel: 'Gorivo',
    },
    prefsTitle: 'Iskačuća obavještenja',
    prefsHint: 'Odaberite koji događaji vozila iskaču. Događaji koji iskoče čuvaju se i u listi obavještenja.',
    savedInstantly: 'Izmjene se spremaju čim promijenite prekidač.',
    toggleAll: 'Sve',
    newNotifications: 'novih obavještenja',
    view: 'Prikaži',
    vehicle: 'Vozilo',
    zone: 'Zona',
    limit: 'ograničenje',
  },

  // User Settings
  usersPage: {
    title: 'Korisnici',
    subtitle: 'Upravljanje korisnicima klijenta i dodeljenim grupama',
    addUser: 'Dodaj korisnika',
    editUser: 'Izmeni korisnika',
    addUserDesc: 'Kreirajte novi korisnički nalog',
    editUserDesc: 'Ažurirajte podatke korisnika i pristup grupama',
    fullName: 'Ime i prezime',
    username: 'Korisničko ime',
    password: 'Lozinka',
    passwordOptional: 'Lozinka (ostavite prazno da ostane trenutna)',
    email: 'Email',
    phone: 'Telefon',
    groups: 'Grupe',
    noGroups: 'Nema dostupnih grupa',
    selectedGroups: 'Izabrane grupe',
    totalUsers: 'Ukupno korisnika',
    allUsers: 'Svi korisnici',
    userAdded: 'Korisnik je uspješno kreiran',
    userUpdated: 'Korisnik je uspješno ažuriran',
    userDeleted: 'Korisnik je uspješno obrisan',
    assignedGroups: 'Dodeljene grupe',
    noAssignedGroups: 'Nema dodijeljenih grupa',
    fullNamePlaceholder: 'Petar Petrović',
    usernamePlaceholder: 'petar.petrovic',
    emailPlaceholder: 'petar@firma.rs',
    phonePlaceholder: '+381 60 123 4567',
  },

  // User Settings
  userSettingsPage: {
    title: 'Podešavanja korisnika',
    subtitle: 'Upravljajte vašim nalogom i preferencama',
    profile: 'Profil',
    profileDesc: 'Vaši lični podaci',
    fullName: 'Ime i prezime',
    email: 'Email',
    phone: 'Telefon',
    role: 'Uloga',
    saveChanges: 'Sačuvaj izmene',
    notifications: 'Obavještenja',
    notificationsDesc: 'Konfigurišite kako primate obavještenja',
    emailNotifications: 'Email obavještenja',
    emailNotificationsDesc: 'Primajte obavještenja putem emaila',
    pushNotifications: 'Push obavještenja',
    pushNotificationsDesc: 'Primajte push obavještenja u pretraživaču',
    alertTypes: 'Tipovi upozorenja',
    speedViolations: 'Prekoračenje brzine',
    fuelAlerts: 'Upozorenja o gorivu',
    geofenceAlerts: 'Geofence upozorenja',
    maintenanceReminders: 'Podsetnici za održavanje',
    preferences: 'Preference',
    preferencesDesc: 'Prilagodite vaše iskustvo',
    language: 'Jezik',
    timezone: 'Vremenska zona',
    distanceUnit: 'Jedinica rastojanja',
    kilometers: 'Kilometri',
    miles: 'Milje',
    dateFormat: 'Format datuma',
    savePreferences: 'Sačuvaj preference',
    security: 'Sigurnost',
    securityDesc: 'Upravljajte sigurnošću vašeg naloga',
    currentPassword: 'Trenutna lozinka',
    newPassword: 'Nova lozinka',
    confirmPassword: 'Potvrdi lozinku',
    updatePassword: 'Ažuriraj lozinku',
    settingsSaved: 'Podešavanja uspješno sačuvana',
    phonePlaceholder: '+381 60 123 4567',
    pacificTime: 'Pacifičko vrijeme (UTC-8)',
    easternTime: 'Istočno vrijeme (UTC-5)',
    centralEuropeanTime: 'Centralnoevropsko vrijeme (UTC+1)',
    dateFormatMdy: 'MM/DD/GGGG',
    dateFormatDmy: 'DD/MM/GGGG',
    dateFormatYmd: 'GGGG-MM-DD',
    utc: 'UTC',
  },

  // System Settings
  systemSettingsPage: {
    title: 'Sistemska podešavanja',
    subtitle: 'Konfigurišite globalne sistemske preference',
    mapSettings: 'Podešavanja mape',
    mapSettingsDesc: 'Konfigurišite prikaz i ponašanje mape',
    refreshInterval: 'Interval osvežavanja (sekunde)',
    showTrafficLayer: 'Prikaži sloj saobraćaja',
    showTrafficDesc: 'Prikaz podataka o saobraćaju u realnom vremenu',
    satelliteView: 'Satelitski prikaz',
    satelliteViewDesc: 'Koristi satelitske snimke',
    clusterMarkers: 'Grupiši markere',
    clusterMarkersDesc: 'Grupiši bliska vozila kada se umanji prikaz',
    alertThresholds: 'Pragovi upozorenja',
    alertThresholdsDesc: 'Postavite pragove za automatska upozorenja',
    speedLimitKmh: 'Ograničenje brzine (km/h)',
    idleTimeoutMin: 'Timeout mirovanja (minuti)',
    lowFuelThreshold: 'Prag niskog nivoa goriva (%)',
    geofenceAlerts: 'Geofence upozorenja',
    geofenceAlertsDesc: 'Upozori kada vozila napuste određene zone',
    saveAlertSettings: 'Sačuvaj podešavanja upozorenja',
    notificationDelivery: 'Dostava obavještenja',
    notificationDeliveryDesc: 'Konfigurišite kako se obavještenja šalju korisnicima',
    emailServer: 'Email server (SMTP)',
    smtpPort: 'SMTP port',
    fromEmail: 'Email pošiljaoca',
    replyToEmail: 'Reply-to email',
    saveNotificationSettings: 'Sačuvaj podešavanja obavještenja',
    dataRetention: 'Čuvanje podataka',
    dataRetentionDesc: 'Konfigurišite politike čuvanja i čišćenja podataka',
    gpsHistoryRetention: 'Čuvanje GPS historije',
    tripHistoryRetention: 'Čuvanje historije putovanja',
    alertHistoryRetention: 'Čuvanje historije upozorenja',
    backupFrequency: 'Učestalost rezervnih kopija',
    days: 'dana',
    year: '1 godina',
    years: '2 godine',
    hourly: 'Svakog sata',
    daily: 'Dnevno',
    weekly: 'Sedmično',
    saveRetentionSettings: 'Sačuvaj podešavanja čuvanja',
    apiIntegrations: 'API i integracije',
    apiIntegrationsDesc: 'Upravljajte API ključevima i integracijama sa trećim stranama',
    apiKey: 'API ključ',
    regenerate: 'Regeneriši',
    apiKeyDesc: 'Koristite ovaj ključ za integraciju sa eksternim sistemima',
    webhookUrl: 'Webhook URL',
    webhookDesc: 'Događaji će biti poslati na ovaj URL u realnom vremenu',
    saveApiSettings: 'Sačuvaj API podešavanja',
    systemSettingsSaved: 'Sistemska podešavanja uspješno sačuvana',
    emailServerPlaceholder: 'smtp.firma.rs',
    smtpPortPlaceholder: '587',
    fromEmailPlaceholder: 'obavestenja@firma.rs',
    replyToEmailPlaceholder: 'podrska@firma.rs',
    webhookUrlPlaceholder: 'https://api.vasafirma.com/webhooks/fleet',
  },

  // Groups
  groupsPage: {
    title: 'Grupe vozila',
    subtitle: 'Organizujte vašu flotu u logičke grupe',
    addGroup: 'Dodaj grupu',
    addNewGroup: 'Dodaj novu grupu',
    addNewGroupDesc: 'Kreirajte novu grupu vozila za vašu flotu',
    groupName: 'Naziv grupe',
    groupNamePlaceholder: 'Unesite naziv grupe...',
    groupColor: 'Boja grupe',
    totalGroups: 'Ukupno grupa',
    avgVehiclesPerGroup: 'Prosečno po grupi',
    allGroups: 'Sve grupe',
    allGroupsDesc: 'Upravljajte vašim grupama vozila i njihovim podešavanjima',
    vehiclesAssigned: 'dodijeljenih vozila',
    editGroup: 'Izmeni grupu',
    editGroupDesc: 'Ažurirajte naziv i boju grupe',
    groupAdded: 'Grupa dodata',
    groupAddedDesc: 'Grupa vozila je uspješno kreirana.',
    groupUpdated: 'Grupa ažurirana',
    groupUpdatedDesc: 'Grupa vozila je uspješno ažurirana.',
    groupDeleted: 'Grupa obrisana',
    groupDeletedDesc: 'Grupa vozila je obrisana.',
    cannotDelete: 'Nije moguće obrisati grupu',
    groupHasVehicles: 'Ova grupa još uvijek ima dodeljena vozila.',
  },

  // Costs
  costsPage: {
    title: 'Troškovi',
    subtitle: 'Troškovi vozila, ponavljajući rasporedi i nadolazeći podsjetnici',
    tabOverview: 'Pregled',
    tabCosts: 'Troškovi',
    tabRecurrences: 'Ponavljanja',
    tabUpcoming: 'Nadolazeće',
    addCost: 'Dodaj trošak',
    addCostDesc: 'Evidentiraj novi trošak za vozilo',
    editCost: 'Izmijeni trošak',
    editCostDesc: 'Ažuriraj zapis o trošku',
    saveChanges: 'Sačuvaj izmjene',
    vehicle: 'Vozilo',
    category: 'Kategorija',
    date: 'Datum',
    amount: 'Iznos',
    currency: 'Valuta',
    costTitle: 'Naziv',
    description: 'Opis',
    odometer: 'Kilometraža',
    planned: 'Planiran',
    unplanned: 'Neplaniran',
    status: 'Status',
    vendor: 'Dobavljač',
    invoiceNo: 'Broj računa',
    documentUrl: 'Link ka dokumentu',
    statusPlanned: 'Planiran',
    statusDone: 'Realizovan',
    statusCancelled: 'Otkazan',
    selectVehicle: 'Odaberi vozilo',
    selectCategory: 'Odaberi kategoriju',
    searchCategories: 'Pretraži kategorije...',
    noCategoriesFound: 'Nema pronađenih kategorija',
    allCategories: 'Sve kategorije',
    allStatuses: 'Svi statusi',
    allVehicles: 'Sva vozila',
    useCurrentOdometer: 'Koristi trenutno stanje',
    totalCost: 'Potrošeno',
    plannedTotal: 'Planirano',
    unplannedTotal: 'Neplanirano',
    costCount: 'Zapisa',
    forecastTotal: 'Prognoza',
    markDone: 'Označi kao realizovano',
    completeCost: 'Potvrdi trošak',
    completeCostDesc: 'Unesite stvarni datum, kilometražu i iznos. Sljedeće dospijeće se računa od njih.',
    costCompleted: 'Trošak označen kao realizovan',
    anchorHint: 'Kada je ovo posljednji put urađeno. Sljedeće dospijeće i kilometraža se računaju od toga.',
    recurrenceInUse: 'Ovo pravilo je već generisalo troškove, pa se ne može obrisati. Deaktivirajte ga da biste zaustavili podsjetnike.',
    deactivate: 'Deaktiviraj',
    recurrenceDeactivated: 'Pravilo deaktivirano',
    recurrenceHistoryDesc: 'Ko je kreirao i mijenjao ovo pravilo, i troškovi koje je generisalo',
    readOnlyNotice: 'Možete pregledati troškove, ali ne i mijenjati ih',
    costPerKm: 'Trošak po km',
    byCategory: 'Po kategoriji',
    byVehicle: 'Vozila sa najvećim troškom',
    overTime: 'Kroz vrijeme',
    noChartData: 'Nema troškova u odabranom periodu',
    addRecurrence: 'Dodaj pravilo',
    addRecurrenceDesc: 'Napravi raspored ponavljajućeg troška',
    editRecurrence: 'Izmijeni pravilo',
    editRecurrenceDesc: 'Ažuriraj raspored ponavljajućeg troška',
    ruleType: 'Ponavlja se',
    ruleInterval: 'Svaki period',
    ruleIntervalDesc: 'Godišnja registracija, mjesečni lizing',
    ruleMileage: 'Na pređene km',
    ruleMileageDesc: 'Servis ulja svakih 15.000 km',
    ruleIntervalAndMileage: 'Km ili period',
    ruleIntervalAndMileageDesc: 'Šta god prvo nastupi',
    ruleFixedDates: 'Fiksni datumi',
    ruleFixedDatesDesc: 'Ljetne i zimske gume',
    intervalValue: 'Svakih',
    intervalUnit: 'Jedinica',
    unitDay: 'Dana',
    unitMonth: 'Mjeseci',
    unitYear: 'Godina',
    mileageInterval: 'Svakih (km)',
    fixedDates: 'Datumi',
    addFixedDate: 'Dodaj datum',
    anchorDate: 'Počevši od',
    anchorOdometer: 'Početna kilometraža',
    estimatedAmount: 'Procijenjeni iznos',
    leadDays: 'Upozori dana ranije',
    leadKm: 'Upozori km ranije',
    ruleActive: 'Aktivno',
    rulePaused: 'Pauzirano',
    nextDue: 'Sljedeće dospijeće',
    nextDueOdometer: 'Dospijeva na',
    noRecurrences: 'Još nema ponavljajućih troškova',
    upcomingTitle: 'Nadolazeći troškovi',
    severityOverdue: 'Kasni',
    severityDueSoon: 'Uskoro dospijeva',
    severityUpcoming: 'Predstoji',
    daysLeft: 'dana preostalo',
    daysOverdue: 'dana kašnjenja',
    kmLeft: 'km preostalo',
    kmOverdue: 'km preko',
    logCost: 'Evidentiraj trošak',
    dismiss: 'Odbaci',
    noUpcoming: 'Ništa ne dospijeva',
    noUpcomingDesc: 'Nema troškova koji dospijevaju u ovom periodu',
    history: 'Historija promjena',
    historyDesc: 'Ko je kreirao i mijenjao ovaj trošak',
    noHistory: 'Još nema historije',
    logCreate: 'kreirao',
    logUpdate: 'izmijenio',
    logDelete: 'obrisao',
    logGenerate: 'automatski generisano',
    logComplete: 'označio kao realizovan',
    systemUser: 'Sistem',
    notSet: 'nije postavljeno',
    createdBy: 'Kreirao',
    updatedBy: 'Posljednji put izmijenio',
    costAdded: 'Trošak je uspješno dodat',
    costUpdated: 'Trošak je uspješno izmijenjen',
    costDeleted: 'Trošak je uspješno obrisan',
    recurrenceAdded: 'Pravilo je uspješno dodato',
    recurrenceUpdated: 'Pravilo je uspješno izmijenjeno',
    recurrenceDeleted: 'Pravilo je uspješno obrisano',
    noCosts: 'Nema evidentiranih troškova',
    reportTitle: 'Izvještaj o troškovima',
    reportSubtitle: 'Troškovi vozila za odabrani period',
  },

  // Activity log
  activityPage: {
    title: 'Dnevnik aktivnosti',
    subtitle: 'Šta je svaki korisnik otvarao, preuzimao i mijenjao',
    user: 'Korisnik',
    allUsers: 'Svi korisnici',
    eventType: 'Radnja',
    allEventTypes: 'Sve radnje',
    resource: 'Oblast',
    allResources: 'Sve oblasti',
    searchPlaceholder: 'Pretraga aktivnosti',
    eventLogin: 'Prijava',
    eventLogout: 'Odjava',
    eventPageView: 'Otvorena stranica',
    eventReportGenerate: 'Generisan izvještaj',
    eventHistoryQuery: 'Pretraga historije',
    eventExportPdf: 'Izvoz u PDF',
    eventExportExcel: 'Izvoz u Excel',
    eventExportMapPdf: 'Izvoz mape u PDF',
    eventCreate: 'Kreirano',
    eventUpdate: 'Izmijenjeno',
    eventDelete: 'Obrisano',
    resourceSession: 'Sesija',
    resourcePage: 'Stranica',
    resourceReport: 'Izvještaj',
    resourceHistory: 'Historija',
    resourceVehicle: 'Vozilo',
    resourceDriver: 'Vozač',
    resourceZone: 'Zona',
    resourcePoi: 'Tačka interesa',
    resourceGroup: 'Grupa',
    resourceUser: 'Korisnik',
    resourceCost: 'Trošak',
    resourceCostCategory: 'Kategorija troška',
    resourceCostRecurrence: 'Ponavljajući trošak',
    summaryTitle: 'Korisnici',
    summarySubtitle: 'Posljednja prijava i aktivnost u odabranom periodu',
    lastLogin: 'Posljednja prijava',
    lastActivity: 'Posljednja aktivnost',
    logins: 'Prijava',
    events: 'Događaja',
    neverLoggedIn: 'Nikada se nije prijavio',
    time: 'Vrijeme',
    action: 'Radnja',
    area: 'Oblast',
    details: 'Detalji',
    path: 'Stranica',
    ipAddress: 'IP adresa',
    noActivity: 'Nema zabilježene aktivnosti',
    moreAvailable: 'Prikazani su samo najnoviji redovi — suzite vremenski period da biste vidjeli stariju aktivnost.',
    notAuthorized: 'Samo za administratore',
    notAuthorizedDesc: 'Dnevnik aktivnosti je dostupan administratorima računa.',
    reportTitle: 'Izvještaj o aktivnosti',
    reportSubtitle: 'Aktivnost korisnika za odabrani period',
  },

  // Toasts
  toast: {
    welcomeBack: 'Dobrodošli nazad!',
  },
};
